export default __webpack_public_path__ + "static/media/image_5.89912c64.png";